import {createSelector} from 'reselect';
import {CommonRootState} from '../types';

export const selectAmbientWeatherConnectedAt = (state: CommonRootState) =>
  state.ambientWeather.link && state.ambientWeather.link.date_connected;

export const selectAmbientWeatherConnected = (state: CommonRootState) =>
  state.ambientWeather.link !== null;

export const selectAmbientWeatherActive = (state: CommonRootState) =>
  state.ambientWeather.link !== null &&
  state.ambientWeather.link.account.active;

const selectAmbientWeatherLink = (state: CommonRootState) =>
  state.ambientWeather.link;

export const getAmbientWeatherStationList = createSelector(
  selectAmbientWeatherLink,
  (link) => {
    if (link !== null) {
      return link.account.weather_stations;
    }
    return [];
  },
);

const getRawCurrentStationId = (state: CommonRootState) =>
  state.ambientWeather.currentStation;

export const getCurrentAmbientWeatherStation = createSelector(
  getRawCurrentStationId,
  getAmbientWeatherStationList,
  (stationId, stationList) => {
    if (stationList.length === 0) {
      return null;
    }
    const currentStation = stationId
      ? stationList.find((item) => item.device_id === stationId) ||
        stationList[0]
      : stationList[0];

    return currentStation;
  },
);
